module.exports = {
  appId:'2022pipeline',//接口appId
  appsecret:'wxs2tfd4diu88df9',//接口appsecret
  wxAppId:'wxe46aed2c3ea9137d',//微信appid
  token: '', //用户token
}
